<template>
  <div class="container">
    <div @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 1 && activeName == 'first'" style=" position: fixed;z-index: 10000; float: left;bottom:0px;right:0px; 
                          color: white;
                          border: 0px;">
      <!--
      <svg style="position: fixed;
    bottom: 10px;
    right: 10px;cursor:pointer;" t="1667367585021" class="icon" viewBox="0 0 1024 1024" version="1.1"
        xmlns="http://www.w3.org/2000/svg" p-id="49889" width="45" height="45">
        <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z"
          fill="#FF934A" p-id="49890"></path>
        <path
          d="M498.56 519.666a10.668 10.668 0 0 1 0-15.332c21.718-21.126 84.97-82.904 148.374-147.128 14.336-14.516 19.86-35.152 7.744-51.408-4.972-6.654-11.584-14.192-20.352-22.284-11.926-11.014-23.296-18.38-32.768-23.28-15.51-8.02-33.686-3.928-47.766 6.24-110.25 79.572-185.43 165.484-221.802 211.612-15.98 20.29-15.98 47.538 0 67.828 36.372 46.128 111.552 132.04 221.802 211.614 14.08 10.166 32.256 14.256 47.766 6.238 9.472-4.9 20.842-12.266 32.768-23.28 8.768-8.092 15.38-15.63 20.352-22.284 12.116-16.256 6.592-36.892-7.744-51.406-63.404-64.226-126.656-126.004-148.374-147.13z"
          fill="#FFFFFF" p-id="49891"></path>
      </svg>

      -->

      <el-image style="width: 45px; height: 45px" src="https://wugecdn.steam.fun/resources/jrcode/back3.png" fit="fit"></el-image>
    </div>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 2 && activeName == 'first'" style="position: fixed;z-index: 10000; float: right;top:8px;right:10px; background: #66b1ff7d;
                          color: white;
                          border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回作品
    </el-button>

    <el-button @click="CloseDrawer" size="medium" v-if="drawer && CourseworkForm.subject_code == 3 && activeName == 'first'" style="position: fixed;z-index: 10000; float: right;top:12px;right:20px; background: #66b1ff7d;
                          color: white;
                          border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回作品
    </el-button>

    <div @click="CloseDrawer" size="medium" v-if="
        drawer && FreeworkForm.subject_code == '1' && activeName == 'second'
      " style=" position: fixed;z-index: 10000; float: left;bottom:0px;right:0px;
                          color: white;
                          border: 0px;">
      <!--
      <svg style="position: fixed;
    bottom: 10px;
    right: 10px;cursor:pointer;" t="1667367585021" class="icon" viewBox="0 0 1024 1024" version="1.1"
        xmlns="http://www.w3.org/2000/svg" p-id="49889" width="45" height="45">
        <path d="M512 64C264.576 64 64 264.576 64 512s200.576 448 448 448 448-200.576 448-448S759.424 64 512 64z"
          fill="#FF934A" p-id="49890"></path>
        <path
          d="M498.56 519.666a10.668 10.668 0 0 1 0-15.332c21.718-21.126 84.97-82.904 148.374-147.128 14.336-14.516 19.86-35.152 7.744-51.408-4.972-6.654-11.584-14.192-20.352-22.284-11.926-11.014-23.296-18.38-32.768-23.28-15.51-8.02-33.686-3.928-47.766 6.24-110.25 79.572-185.43 165.484-221.802 211.612-15.98 20.29-15.98 47.538 0 67.828 36.372 46.128 111.552 132.04 221.802 211.614 14.08 10.166 32.256 14.256 47.766 6.238 9.472-4.9 20.842-12.266 32.768-23.28 8.768-8.092 15.38-15.63 20.352-22.284 12.116-16.256 6.592-36.892-7.744-51.406-63.404-64.226-126.656-126.004-148.374-147.13z"
          fill="#FFFFFF" p-id="49891"></path>
      </svg>
      -->
      <el-image style="width: 45px; height: 45px" src="https://wugecdn.steam.fun/resources/jrcode/back3.png" fit="fit"></el-image>
    </div>

    <el-button @click="CloseDrawer" size="medium" v-if="
        drawer && FreeworkForm.subject_code == '2' && activeName == 'second'
      " style="position: fixed;z-index: 10000; float: right;top:8px;right:10px; background: #66b1ff7d;
                          color: white;
                          border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回作品
    </el-button>

    <el-button @click="CloseDrawer" size="medium" v-if="
        drawer && FreeworkForm.subject_code == '3' && activeName == 'second'
      " style="position: fixed;z-index: 10000; float: right;top:12px;right:20px; background: #66b1ff7d;
                          color: white;
                          border: 0px;">
      <svg t="1665542150306" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2543" width="15" height="15">
        <path d="M1024 505.679012c0-10.835979-4.815991-21.069959-12.039976-27.691946l-403.941211-361.199295c-6.621987-5.417989-14.447972-9.029982-23.477954-9.029982-20.46796 0-36.721928 16.855967-36.721928 37.925926l0 159.529688C238.993533 356.985303 21.069959 591.764844 0 893.366255c1.203998 12.641975 11.437978 22.875955 23.477954 22.875955 4.815991 0 9.631981-1.805996 13.243974-4.213992 0 0 0 0 0 0 53.577895-39.129924 99.329806-68.627866 135.449735-87.891828 87.28983-49.965902 222.739565-89.697825 375.045267-105.951793l0 148.091711c0 21.069959 16.253968 37.925926 36.721928 37.925926 8.427984 0 16.253968-3.611993 22.875955-8.427984l403.941211-361.199295c0 0 0 0 0 0C1019.184009 527.35097 1024 517.11699 1024 505.679012z" p-id="2544" fill="#ffffff"></path>
        <path d="M467.151088 380.463257c-33.711934 6.019988-96.921811 24.681952-139.061728 80.667842-7.223986 9.029982-5.417989 22.875955 3.611993 30.099941 0 0 0 0 0.601999 0 9.029982 7.223986 21.671958 5.417989 28.895944-3.009994 23.477954-28.895944 51.771899-57.189888 111.971781-65.015873 9.631981-1.203998 17.457966-9.631981 17.457966-19.865961l0-3.009994C490.027043 387.687243 478.589065 378.65726 467.151088 380.463257z" p-id="2545" fill="#ffffff"></path>
        <path d="M323.273369 518.320988C322.67137 518.320988 322.67137 518.320988 323.273369 518.320988c-12.039976-6.019988-25.885949 0.601999-28.895944 12.641975-2.407995 9.631981-4.815991 19.865961-6.019988 30.70194-1.805996 12.039976 7.223986 22.875955 19.263962 22.875955l3.611993 0c10.23398 0 18.661964-7.825985 19.263962-17.457966 0.601999-7.825985 1.805996-13.243974 4.213992-24.681952C337.119342 532.768959 331.701352 522.534979 323.273369 518.320988z" p-id="2546" fill="#ffffff"></path>
      </svg>
      返回作品
    </el-button>

    <div class="school-body">
      <el-row>
        <el-col :span="24">
          <div class="classwrapper">
            <el-row>
              <el-col :span="24">
                <div class="coursework">
                  <el-tabs v-model="activeName" @tab-click="handleClickTab">
                    <el-tab-pane label="课堂作品" name="first">
                      <works></works>
                    </el-tab-pane>

                    <el-tab-pane label="自由创作" name="second">
                      <el-form ref="form" :model="FreeworkForm" :inline="true" size="mini">
                        <el-form-item label="所属科目">
                          <el-select v-model="FreeworkForm.subject_code" placeholder="请选择科目" style="width: 100px" filterable @change="changeSubject">
                            <el-option :label="item.name" :value="item.code" v-for="(item, index) of subjectList" :key="index"></el-option>
                          </el-select>
                        </el-form-item>

                        <el-form-item label="作品名称">
                          <el-input clearable style="width: 200px" v-model="FreeworkForm.title" placeholder="请输入作品名称">
                          </el-input>
                        </el-form-item>
                        <el-form-item label="学员姓名">
                          <el-input clearable style="width: 200px" v-model="FreeworkForm.stuRealName" placeholder="请输入学员姓名">
                          </el-input>
                        </el-form-item>

                        <el-form-item size="mini">
                          <el-button type="primary" @click="tchGetTchStuWorkList">查询</el-button>
                        </el-form-item>
                      </el-form>

                      <el-row :gutter="20">
                        <el-col :span="25" v-for="item of FreeWorkList" :key="item.id">
                          <el-card shadow="hover">
                            <div class="worklist">
                              <div class="worklist_imgwrapper" @click="LookWork(item)">
                                <el-image class="workimg" :src="item.covers" fit="fill"></el-image>
                              </div>

                              <div class="work_title">
                                <el-tooltip class="item" effect="dark" :content="item.title" placement="top-start">
                                  <span class="work_title_span">{{
                                    item.title.slice(0, 15)
                                  }}</span>
                                </el-tooltip>

                                <!-- <br /> -->
                                <div style="overflow: hidden;">
                                  <div style="float: left;">
                                    <span style="margin-left: 10px" class="el-icon-thumb">
                                      <span style="margin-left: 5px">{{
                                        item.zan
                                      }}</span>
                                    </span>
                                    <span style="margin-left: 10px" class="el-icon-view"><span style="margin-left: 5px">{{
                                        item.looks
                                      }}</span></span>
                                  </div>
                                  <div style="float: right;padding-right: 10px;">
                                    {{ item.update_time }}
                                  </div>
                                </div>
                              </div>

                              <div style="margin: 5px">
                                <el-row>
                                  <el-col :span="4">
                                    <div class="work_stuinfo">
                                      <el-avatar size="small" class="work_stuinfo_avatar" :src="item.headImgUrl">
                                      </el-avatar>
                                    </div>
                                  </el-col>

                                  <el-col :span="8">
                                    <div class="work_stuinfo_name">
                                      <el-tooltip class="item" effect="dark" :content="item.name" placement="top-start">
                                        <span class="work_stuinfo_name_span">{{
                                          item.name.slice(0, 4)
                                        }}</span>
                                      </el-tooltip>
                                    </div>
                                  </el-col>

                                  <el-col :span="12">
                                    <div style="text-align: right" class="work_stuinfo_name">
                                      <span slot="reference" style="
                                                            margin-right: 10px;
                                                            cursor: pointer;
                                                            color: #e6a23c;
                                                            font-weight: bold;
                                                          " class="
                                                            work_stuinfo_name_span
                                                            el-icon-delete
                                                          " @click="deleteStuWork(item)">
                                        删除
                                      </span>
                                      <span v-if="isShow" style="
                                                            margin-right: 10px;
                                                            cursor: pointer;
                                                            color: #e6a23c;
                                                            font-weight: bold;
                                                          " @click="CreatBill(item)">
                                        海报
                                      </span>
                                    </div>
                                  </el-col>
                                </el-row>
                              </div>
                            </div>
                          </el-card>
                        </el-col>
                      </el-row>

                      <div style="margin: 20px; text-align: right">
                        <el-pagination @current-change="handleCurrentChange1" :current-page="page_no1" :page-size="page_size1" layout="total, prev, pager, next, jumper" :total="total1">
                        </el-pagination>
                      </div>
                    </el-tab-pane>
                  </el-tabs>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>

      <!--点评作业弹窗-->
      <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible" top="5vh" width="80%">
        <el-row>
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    {{ work_title }}
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    <span style="font-size: 12px">
                      发布于：{{ workinfo.created_time }}</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple-light">
                    <span style="font-size: 12px">
                      更新于：{{ workinfo.update_time }}</span>
                  </div>
                </el-col>
              </el-row>

              <iframe style="margin-top: 10px; border: 0px" :src="
                  '/scratch/player.html?work_title=' +
                    work_title +
                    '&work_url=' +
                    work_url +
                    '&scale=' +
                    scale
                " :width="frameWidth" :height="frameHeight"></iframe>

              <el-row>
                <el-col :span="24">
                  <div style="font-size: 14px; margin-top: 10px" class="grid-content bg-purple-dark">
                    <ul>
                      <el-button style="margin-right: 20px" type="text" class="el-icon-view" @click="CommentCode">批改源码
                      </el-button>

                      <el-popover placement="top-start" title="手机分享" width="150" trigger="click" content="手机分享作品，赶快体验吧!">
                        <div id="qrcodeImg"></div>
                        <el-button type="text" @click="qrcode" slot="reference" style="margin-right: 20px; cursor: pointer" class="el-icon-share">分享</el-button>
                      </el-popover>
                    </ul>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
          <el-col :span="10">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    老师点评
                  </div>
                </el-col>
              </el-row>

              <el-form :model="markform" ref="ruleForm" label-width="100px" label-position="top" size="mini" style="margin-top: 10px" class="demo-ruleForm">
                <el-form-item label="作品等级" prop="markpoint">
                  <el-rate disabled v-model="markform.markpoint"> </el-rate>
                </el-form-item>
                <el-form-item label="作品推优" prop="is_good">
                  <el-switch disabled v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="remark">
                  <span style="margin-top: 10px"> {{ markform.remark }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>

      <!--点评作业弹窗-->
      <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible1" top="5vh" width="80%">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    {{ work_title }}
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    <span style="font-size: 12px">
                      发布于：{{ workinfo.created_time }}</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple-light">
                    <span style="font-size: 12px">
                      更新于：{{ workinfo.update_time }}</span>
                  </div>
                </el-col>
              </el-row>
              <iframe style="margin-top: 10px; border: 0px" :src="'/jrcode/teashow.html?mode=look&filepath=' + work_url" :width="frameWidth1" :height="frameHeight1"></iframe>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    老师点评
                  </div>
                </el-col>
              </el-row>

              <el-form :model="markform" ref="ruleForm" label-width="100px" :inline="true" size="mini" style="margin-top: 10px" class="demo-ruleForm">
                <el-form-item label="作品等级" prop="markpoint">
                  <el-rate disabled v-model="markform.markpoint"> </el-rate>
                </el-form-item>
                <el-form-item label="作品推优" prop="is_good">
                  <el-switch disabled v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="remark">
                  <span style="margin-top: 10px"> {{ markform.remark }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>

      <!--PYTHON点评作业弹窗-->
      <el-dialog class="comment" title="课堂作品" :visible.sync="dialogFormVisible2" top="5vh" width="80%">
        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    {{ work_title }}
                  </div>
                </el-col>
              </el-row>

              <el-row style="margin-top: 10px">
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple">
                    <span style="font-size: 12px">
                      发布于：{{ workinfo.created_time }}</span>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div style="line-height: 30px" class="grid-content bg-purple-light">
                    <span style="font-size: 12px">
                      更新于：{{ workinfo.update_time }}</span>
                  </div>
                </el-col>
              </el-row>
              <iframe style="margin-top: 10px; border: 0px" :src="python_work_url" :width="frameWidth2" :height="frameHeight"></iframe>
            </div>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="24">
            <div class="grid-content bg-purple-light">
              <el-row>
                <el-col :span="24">
                  <div style="font-size: 16px; font-weight: 500" class="grid-content bg-purple-dark">
                    老师点评
                  </div>
                </el-col>
              </el-row>

              <el-form :model="markform" ref="ruleForm" label-width="100px" :inline="true" size="mini" style="margin-top: 10px" class="demo-ruleForm">
                <el-form-item label="作品等级" prop="markpoint">
                  <el-rate disabled v-model="markform.markpoint"> </el-rate>
                </el-form-item>
                <el-form-item label="作品推优" prop="is_good">
                  <el-switch disabled v-model="markform.is_good"></el-switch>
                </el-form-item>
                <el-form-item label="教师评语" prop="remark">
                  <span style="margin-top: 10px"> {{ markform.remark }}</span>
                </el-form-item>
              </el-form>
            </div>
          </el-col>
        </el-row>
      </el-dialog>
    </div>

    <el-drawer class="container1" :with-header="false" title="查看作品 (点击右上角X号退出)" size="100%" :visible.sync="drawer" :direction="direction" :destroy-on-close="true" @close="Search">
      <iframe id="iframe_project1" width="100%" height="100%" :src="project_url"></iframe>
    </el-drawer>

    <el-dialog title="作品海报" :visible.sync="dialogVisible2" width="500px" top="5vh">
      <el-row :gutter="20">
        <el-col :span="18">
          <div>
            <el-image id="myCanvas" :src="posterImg" fit="fill"></el-image>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple-light">
            <el-form size="mini" ref="form" :model="form_share" label-position="top">
              <el-form-item label="样式">
                <el-select style="width: 100px" v-model="form_share.type" placeholder="选择样式" @change="ChangeShareType">
                  <el-option label="样式一" value="1"></el-option>
                  <el-option label="样式二" value="2"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="颜色">
                <el-select style="width: 100px" v-model="form_share.color" placeholder="选择颜色" @change="ChangeShareColor">
                  <el-option label="蓝色" value="1"></el-option>
                  <el-option label="绿色" value="2"></el-option>
                  <el-option label="品红" value="3"></el-option>
                  <el-option label="红色" value="4"></el-option>
                  <el-option label="黄色" value="5"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item>
                <el-button type="primary" @click="CreateShareImg" :loading="share_loading">生成海报</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-col>
      </el-row>
    </el-dialog>

    <!--分享海报页面-->
    <div id="posterHtml2" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2408px' : '2208px',
        backgroundColor:imgColorMap[form_share.color]
      }">
      <div style="position: relative; top: 740px; text-align: center">
        <span style="font-weight: bold; color: white; font-size: 80px">{{
          form_share.title
        }}</span><br />
        <span style="color: white; font-size: 50px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <el-image style="margin-top: 765px; left: 180px; width: 902px; height: 665px" :src="form_share.cover" fit="fill">
      </el-image>

      <div id="qrcodeWorkImg2" style="margin-left: 780px; margin-top: 108px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
    </div>

    <div id="posterHtml3" v-show="false" :style="{
        backgroundImage: 'url(' + share_img + ')',
        backgroundRepeat: 'no-repeat',
        position: 'absolute',
        top: '0px',
        width: '1242px',
        height: schoolLogoUrl ? '2408px' : '2208px',
        backgroundColor:imgColorMap[form_share.color]
      }">
      <el-image style="margin-top: 618px; left: 122px; width: 1004px; height: 753px" :src="form_share.cover" fit="fill">
      </el-image>

      <div style="position: relative; top: 10px; text-align: center">
        <span style="font-weight: bold; color: #333333; font-size: 60px">{{
          form_share.title
        }}</span><br />
        <span style="color: #333333; font-size: 40px">{{
          '作者:' + form_share.name
        }}</span>
      </div>

      <div style="margin-left: 230px; margin-top: 33px; color: #f7ba2a">
        <i v-for="count in form_share.star_num" :key="count" class="el-icon-star-on" style="font-size: 100px; margin: 10px">
        </i>
      </div>

      <div v-if="form_share.star_num" id="qrcodeWorkImg3" style="margin-left: 135px; margin-top: 212px"></div>
      <div v-else id="qrcodeWorkImg3" style="margin-left: 135px; margin-top: 365px"></div>
      <div class="school-logo" v-if="schoolLogoUrl" :style="{boxSizing:'content-box',position:'absolute',bottom:0,left:0,display:'flex',justifyContent:'center',alignItems:'center',width:'100%',height:'202px',padding:'25px 0',backgroundColor:imgColorMap[form_share.color]}">
        <img :src="schoolLogoUrl" alt="" style="height:100%" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  tchGetTchStuTchWorkList,
  tchGetTchStuWorkList,
  tchGetTchSubjectAuth,
  tchDeleteTchWork,
} from '@/api/classroom/teacher_api'

import { deleteScWork, deleteJrWork, deletePyWork } from '@/api/community'

import QRCode from 'qrcodejs2' // 引入qrcode
import html2canvas from 'html2canvas'
import moment from 'moment'
import works from '@/components/works'

export default {
  components: {
    works,
  },
  name: 'classlistWorksStu',
  data() {
    return {
      isShow: false,
      value: null,
      ruleForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 3, max: 5, message: '长度在 3 到 5 个字符', trigger: 'blur' },
        ],
        region: [
          { required: true, message: '请选择活动区域', trigger: 'change' },
        ],
        date1: [
          {
            type: 'date',
            required: true,
            message: '请选择日期',
            trigger: 'change',
          },
        ],
        date2: [
          {
            type: 'date',
            required: true,
            message: '请选择时间',
            trigger: 'change',
          },
        ],
        type: [
          {
            type: 'array',
            required: true,
            message: '请至少选择一个活动性质',
            trigger: 'change',
          },
        ],
        resource: [
          { required: true, message: '请选择活动资源', trigger: 'change' },
        ],
        desc: [{ required: true, message: '请填写活动形式', trigger: 'blur' }],
      },
      dialogFormVisible: false,
      dialogFormVisible1: false,
      dialogFormVisible2: false,
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      formLabelWidth: '120px',

      activeName: 'first',
      radio1: '上海',
      radio: '3',
      sizeForm: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
      CourseworkForm: {
        creatTime1: [],
        subject_code: '',
        is_marking: '',
        title: '',
      },

      FreeworkForm: {
        subject_code: '',
        is_marking: '',
        title: '',
      },

      CourseWorkList: [],
      FreeWorkList: [],

      //查看评语
      work_title: '',
      workinfo: {},
      markform: {},
      work_url: '',
      work_id: '',
      subjectList: [],

      //课堂作品
      page_no: 1,
      page_size: 20,
      total: 0,
      //自由创作
      page_no1: 1,
      page_size1: 20,
      total1: 0,

      //作品尺寸适配
      frameWidth: 0, // 屏幕宽
      frameHeight: 0, // 屏幕高
      scale: 0,

      //JRCODE作品点评
      frameWidth1: 0, // 屏幕宽
      frameHeight1: 0, // 屏幕高

      //PYTHON作品点评
      frameWidth2: 0, // 屏幕宽
      frameHeight2: 0, // 屏幕高
      python_work_url: '',

      drawer: false,
      direction: 'ltr',
      project_url: '',
      //生成海报
      dialogVisible2: false, //分享海报窗口

      posterContent: '很不错', // 文案内容
      posterHtmlBg:
        'https://wugecdn.steam.fun/courses/b_scratch_course/bb_general_course/version2.0/poster/09%E5%B0%8F%E5%BF%83%E9%9B%AA%E5%B4%A9.png', // 背景图
      posterImg: '', // 最终生成的海报图片

      share_img: '', //默认海报
      share_type: '1', //海报类型

      form_share: {
        work_id: '',
        type: '1',
        color: '1',
        cover: '',
        title: '',
        name: '',
        star_num: 0,
        images1: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_1.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_1.png',
        ],
        images2: [
          'https://wugecdn.steam.fun/resources/static/work_share/bg_blue_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_green_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_pink_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_red_2.png',
          'https://wugecdn.steam.fun/resources/static/work_share/bg_yellow_2.png',
        ],
      },
      share_loading: false, //生成海报加载

      coursework_subject_id: '', //课堂作品科目id
      freework_subject_id: '', //自由创作科目id
      pickerOptions: {
        shortcuts: [
          {
            text: '今日',
            onClick(picker) {
              const start = moment().format('YYYY-MM-DD 00:00:00')
              const end = moment().format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week())
                  .startOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week())
                  .endOf('week')
                  .add(1, 'days')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              console.log(start, 1234165)
              console.log(end, 1234165)

              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上周',
            onClick(picker) {
              const start = moment(
                moment()
                  .week(moment().week() - 1)
                  .startOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .week(moment().week() - 1)
                  .endOf('week')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本月',
            onClick(picker) {
              const start = moment()
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上月',
            onClick(picker) {
              const start = moment()
                .subtract(1, 'month')
                .startOf('month')
                .format('YYYY-MM-DD 00:00:00')
              const end = moment()
                .subtract(1, 'month')
                .endOf('month')
                .format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter())
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter())
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上季度',
            onClick(picker) {
              const start = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .startOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .quarter(moment().quarter() - 1)
                  .endOf('quarter')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '本年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year())
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year())
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '上年',
            onClick(picker) {
              const start = moment(
                moment()
                  .year(moment().year() - 1)
                  .startOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 00:00:00')
              const end = moment(
                moment()
                  .year(moment().year() - 1)
                  .endOf('year')
                  .valueOf()
              ).format('YYYY-MM-DD 23:59:59')
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      schoolLogoUrl: '',
      imgColorMap: {
        1: '#2EB3FF',
        2: '#35B72A',
        3: '#FF63B1',
        4: '#FF5B5C',
        5: '#FFBD4A',
      },
    }
  },

  watch: {
    activeName: function () {
      if (this.activeName == 'first') {
        console.log(12316)
      } else {
        this.tchGetTchStuWorkList()
      }
    },

    'CourseworkForm.subject_code': function (val) {
      console.log(val, 1245)
      if (val === 2) {
        this.isShow = true
      } else {
        this.isShow = false
      }

      this.tchGetTchStuTchWorkList()
    },
    'FreeworkForm.subject_code': function () {
      this.tchGetTchStuWorkList()
    },
  },

  mounted() {
    const startDate = moment()
      .month(moment().month())
      .startOf('month')
      .format('YYYY-MM-DD 00:00:00')
    const endDate = moment()
      .month(moment().month())
      .endOf('month')
      .format('YYYY-MM-DD 23:59:59')
    this.CourseworkForm.creatTime1.push(startDate, endDate)
    //this.tchGetTchStuTchWorkList();
    document.getElementsByClassName('header-menu-container')[0].style.display =
      'none'
    this.tchGetTchSubjectAuth() //获得老师科目权限

    console.log('IFRAME 宽度')
    console.log(this.screenWidth)

    this.frameWidth = document.documentElement.clientWidth * 0.8 * 0.583 - 50
    this.frameHeight = this.frameWidth * 0.75 + 55

    this.frameWidth1 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight1 = this.frameWidth1 * 0.5 + 55

    this.frameWidth2 = document.documentElement.clientWidth * 0.8 - 50
    this.frameHeight2 = this.frameWidth1 * 0.5 + 55

    this.scale = this.frameWidth / 480
    console.log('比例:' + this.scale)
    console.log(this.frameWidth)
    console.log(this.frameHeight)
    const schoolInfo = JSON.parse(sessionStorage.getItem('schoolInfo'))
    if (schoolInfo) {
      this.schoolLogoUrl = schoolInfo.homepageData.homepage.logo_img_url
    }
  },
  methods: {
    CloseDrawer() {
      console.log('关闭')
      this.$confirm('确定要返回吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.drawer = false
      })
    },

    changeSubject(val) {
      console.log(val)
      if (val === 2) {
        this.isShow = true
      } else {
        this.isShow = false
      }
    },

    CreatBill(row) {
      console.log('生成海报')
      console.log(row)
      this.form_share.cover = row.covers
      this.form_share.work_id = row.id
      this.form_share.title = row.title
      this.form_share.name = row.name
      this.form_share.star_num = row.markpoint
      this.dialogVisible2 = true

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
        this.qrcode_work()
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
        this.qrcode_work1()
      }

      this.share_img = this.posterImg
    },
    CreateShareImg() {
      this.share_loading = true

      // 生成海报
      const vm = this
      console.log(vm.form_share.type, 123456)

      if (vm.form_share.type == '1') {
        const domObj = document.getElementById('posterHtml2')
        console.log('分享海报-样式一')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml2')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      } else if (vm.form_share.type == '2') {
        const domObj = document.getElementById('posterHtml3')
        console.log('分享海报-样式二')
        console.log(domObj)
        html2canvas(domObj, {
          useCORS: true,
          allowTaint: false,
          logging: false,
          letterRendering: true,
          onclone(doc) {
            let e = doc.querySelector('#posterHtml3')
            e.style.display = 'block'
          },
        }).then(function (canvas) {
          // 在微信里,可长按保存或转发
          vm.posterImg = canvas.toDataURL('image/png')
          console.log('生成的海报')
          console.log(canvas)
          console.log(vm.posterImg)
          vm.share_loading = false
          vm.$confirm('海报已生成,是否下载?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'success',
          }).then(() => {
            vm.DownloadImage()
          })
        })
      }
    },

    ChangeShareType() {
      console.log('更换海报样式')
      console.log(this.form_share.type)
      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
        this.qrcode_work()
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
        this.qrcode_work1()
      }

      this.share_img = this.posterImg
    },

    ChangeShareColor() {
      console.log('更换海报颜色')
      console.log(this.form_share.color)

      if (this.form_share.type == '1') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images1[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images1[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images1[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images1[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images1[4]
        }
      } else if (this.form_share.type == '2') {
        if (this.form_share.color == '1') {
          this.posterImg = this.form_share.images2[0]
        } else if (this.form_share.color == '2') {
          this.posterImg = this.form_share.images2[1]
        } else if (this.form_share.color == '3') {
          this.posterImg = this.form_share.images2[2]
        } else if (this.form_share.color == '4') {
          this.posterImg = this.form_share.images2[3]
        } else if (this.form_share.color == '5') {
          this.posterImg = this.form_share.images2[4]
        }
      }

      this.share_img = this.posterImg
    },

    qrcode_work() {
      document.getElementById('qrcodeWorkImg2').innerHTML = ''
      new QRCode('qrcodeWorkImg2', {
        width: 365,
        height: 365,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=1&work_id=' +
          this.form_share.work_id +
          '&subject_code=2', // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    qrcode_work1() {
      document.getElementById('qrcodeWorkImg3').innerHTML = ''
      new QRCode('qrcodeWorkImg3', {
        width: 240,
        height: 240,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=1&work_id=' +
          this.form_share.work_id +
          '&subject_code=2', // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })
    },

    DownloadImage() {
      console.log('下载分享海报')
      console.log(this.posterImg)

      // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
      if (window.navigator.msSaveOrOpenBlob) {
        const bstr = atob(this.posterImg.split(',')[1])
        let n = bstr.length
        const u8arr = new Uint8Array(n)
        while (n--) {
          u8arr[n] = bstr.charCodeAt(n)
        }
        const blob = new Blob([u8arr])
        window.navigator.msSaveOrOpenBlob(blob, 'chart-download' + '.' + 'png')
      } else {
        // 这里就按照chrome等新版浏览器来处理
        const a = document.createElement('a')
        a.href = this.posterImg
        a.setAttribute('download', 'chart-download')
        a.click()
      }
    },

    compileStr(code) {
      //对字符串进行加密
      var c = String.fromCharCode(code.charCodeAt(0) + code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) + code.charCodeAt(i - 1))
      }
      return escape(c)
    },

    //字符串进行解密
    uncompileStr(code) {
      code = unescape(code)
      var c = String.fromCharCode(code.charCodeAt(0) - code.length)
      for (var i = 1; i < code.length; i++) {
        c += String.fromCharCode(code.charCodeAt(i) - c.charCodeAt(i - 1))
      }
      return c
    },

    handleCurrentChange(val) {
      this.page_no = val
      this.tchGetTchStuTchWorkList()
    },

    handleCurrentChange1(val) {
      this.page_no1 = val
      this.tchGetTchStuWorkList()
    },

    handleSizeChange(val) {
      this.page_size = val
      this.tchGetTchStuTchWorkList()
    },

    //获取学校科目权限列表
    tchGetTchSubjectAuth() {
      console.log('查询老师科目权限')
      tchGetTchSubjectAuth().then((res) => {
        this.subjectList = res.subjectList
        console.log('获取老师权限列表')
        console.log(res)

        if (res.subjectList.length == 0) {
          this.$message.warning('无科目权限')
          return
        }

        this.CourseworkForm.subject_code = res.subjectList[0].code
        this.FreeworkForm.subject_code = res.subjectList[0].code

        console.log('默认科目')
        console.log(this.CourseworkForm)
      })
    },

    LookMark(item) {
      console.log('查看课堂作品')
      console.log(item)
      this.workinfo = item
      this.markform.is_good = item.is_good
      this.markform.markpoint = item.markpoint
      this.markform.remark = item.remark
      this.work_title = item.title
      this.work_url = item.work_url
      this.coursework_subject_id = item.stuTchPlanInfo.subject_id

      if (this.activeName == 'first') {
        console.log('查看课堂作品')
        if (this.CourseworkForm.subject_code == '1') {
          console.log('JRCDOE课堂作品')

          this.project_url =
            '/jrcode/teachjr.html?role=teach&type=5&mode=edit&filepath=' +
            item.work_url +
            '&stu_user_id=' +
            item.stu_user_id +
            '&stu_tch_plan_id=' +
            item.stu_tch_plan_id +
            '&work_type=' +
            item.work_type
          this.drawer = true
        } else if (this.CourseworkForm.subject_code == '2') {
          console.log('SC作品查看')
          this.project_url =
            '/scratch/teachsc.html?workurl=' +
            this.compileStr(item.work_url).replace(/%/g, '%25') +
            '&workname=' +
            item.title +
            '&stu_user_id=' +
            item.stu_user_id +
            '&stu_tch_plan_id=' +
            item.stu_tch_plan_id +
            '&work_type=' +
            item.work_type +
            '&mode=4'
          this.drawer = true
        } else if (this.CourseworkForm.subject_code == '3') {
          console.log('PY课堂作品')
          if (localStorage.getItem('current_py_version') == 'v2') {
            this.project_url =
              '/python/teachpy_v2?mode=4&title=' +
              this.work_title +
              '&stu_user_id=' +
              item.stu_user_id +
              '&stu_tch_plan_id=' +
              item.stu_tch_plan_id +
              '&work_type=' +
              item.work_type
          } else if (localStorage.getItem('current_py_version') == 'v1') {
            this.project_url =
              '/python/teachpy?mode=4&title=' +
              this.work_title +
              '&stu_user_id=' +
              item.stu_user_id +
              '&stu_tch_plan_id=' +
              item.stu_tch_plan_id +
              '&work_type=' +
              item.work_type
          } else {
            this.project_url =
              '/python/teachpy_v2?mode=4&title=' +
              this.work_title +
              '&stu_user_id=' +
              item.stu_user_id +
              '&stu_tch_plan_id=' +
              item.stu_tch_plan_id +
              '&work_type=' +
              item.work_type
          }

          this.$store.commit('SET_TEACH_TEMPLATE_URL', item.work_url || '')

          this.$store.commit(
            'SET_HOME_TEMPLATE_URL',
            item.stuTchPlanInfo.techPlanInfo.lessionInfo.home_template_url || ''
          )

          this.drawer = true
        } else if (this.CourseworkForm.subject_code == '4') {
          this.cpp_url =
            '/cpp?' +
            '&lesson_id=' +
            item.stuTchPlanInfo.techPlanInfo.curriculum_meterial_id +
            '&stu_id=' +
            item.stu_user_id +
            '&type=' +
            item.work_type +
            '&userType=' +
            'stu'
          sessionStorage.setItem('lecturesTitle', item.title)
          sessionStorage.setItem('sbj', '4')

          window.open(this.cpp_url, '_blank')
        }
      }
    },

    //跳转到作品详情页面
    LookWork(item) {
      console.log('跳转到作品详情页面')
      console.log(item)

      console.log(this.FreeworkForm.subject_code)

      if (this.activeName == 'second') {
        console.log('自由创作作品列表')
        if (this.FreeworkForm.subject_code == '1') {
          console.log('自由创作-Jrcode')
          this.project_url =
            '/jrcode/teachjr.html?role=teach&type=6&filepath=' +
            item.work_url +
            '&mode=edit'
          this.drawer = true
        } else if (this.FreeworkForm.subject_code == '2') {
          console.log('自由创作-Scratch')
          this.project_url =
            '/scratch/teachsc.html?workurl=' +
            this.compileStr(item.work_url).replace(/%/g, '%25') +
            '&workname=' +
            item.title
          this.drawer = true
        } else if (this.FreeworkForm.subject_code == '3') {
          console.log('python作品编辑')

          if (localStorage.getItem('current_py_version') == 'v2') {
            this.project_url =
              '/python/teachpy_v2?&mode=1&type=1&title=' + item.title
          } else if (localStorage.getItem('current_py_version') == 'v1') {
            this.project_url =
              '/python/teachpy?&mode=1&type=1&title=' + item.title
          } else {
            this.project_url =
              '/python/teachpy?&mode=1&type=1&title=' + item.title
          }

          this.$store.commit('SET_EXAM_WORK_URL', item.work_url || '')
          this.drawer = true
        }
      }
    },

    SearchStuTchWorkList() {
      this.page_no = 1
      this.tchGetTchStuTchWorkList()
    },

    Search() {
      if (this.activeName == 'first') {
        this.tchGetTchStuTchWorkList()
      }
    },

    tchGetTchStuTchWorkList() {
      if (!this.CourseworkForm.subject_code) {
        this.$message.warning('请选择科目')
        return
      }

      tchGetTchStuTchWorkList({
        tch_plan_sign_date_start:
          this.CourseworkForm.creatTime1 === null
            ? ''
            : this.CourseworkForm.creatTime1[0],
        tch_plan_sign_date_end:
          this.CourseworkForm.creatTime1 === null
            ? ''
            : this.CourseworkForm.creatTime1[1],
        stuRealName: this.CourseworkForm.stuRealName,
        subject_code: this.CourseworkForm.subject_code,
        is_marking: '',
        title: this.CourseworkForm.title,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('学生课堂作品')
        console.log(res)
        this.CourseWorkList = res.workList
        this.total = res.total
      })
    },

    //获得学生自由创作作品
    tchGetTchStuWorkList() {
      if (!this.FreeworkForm.subject_code) {
        this.$message.warning('请选择科目')
        return
      }

      tchGetTchStuWorkList({
        subject_code: this.FreeworkForm.subject_code,
        title: this.FreeworkForm.title,
        stuRealName: this.FreeworkForm.stuRealName,
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('学生课堂作品')
        console.log(res)
        this.FreeWorkList = res.workList
        this.total1 = res.total
      })
    },

    //删除自由创作作品
    deleteStuWork(item) {
      this.$confirm('确定删除该学员的作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        if (this.FreeworkForm.subject_code == '1') {
          console.log('删除JR作品')
          deleteJrWork({
            work_id: item.id,
          }).then((res) => {
            console.log('删除作品')
            console.log(res)
            if (res.is_delete) {
              this.$message.success('删除成功')
              this.tchGetTchStuWorkList()
            }
          })
        } else if (this.FreeworkForm.subject_code == '2') {
          console.log('删除SC作品')
          deleteScWork({
            work_id: item.id,
          }).then((res) => {
            console.log('删除作品')
            console.log(res)
            if (res.is_delete) {
              this.$message.success('删除成功')
              this.tchGetTchStuWorkList()
            }
          })
        } else if (this.FreeworkForm.subject_code == '3') {
          console.log('删除PY作品')
          deletePyWork({
            work_id: item.id,
          }).then((res) => {
            console.log('删除作品')
            console.log(res)
            if (res.is_delete) {
              this.$message.success('删除成功')
              this.tchGetTchStuWorkList()
            }
          })
        }
      })
    },

    tchDeleteTchWork(item) {
      this.$confirm('确定删除学员提交的作品吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        tchDeleteTchWork({
          tch_work_id: item.id,
          subject_code: this.CourseworkForm.subject_code,
        }).then((res) => {
          console.log('删除学员课堂作品')
          console.log(res)
          if (res.is_delete) {
            this.$message.success('删除成功')
            this.tchGetTchStuTchWorkList()
          }
        })
      })
    },

    onSubmit() {
      console.log('submit!')
    },
    handleClickTab(tab, event) {
      console.log(tab, event)
    },
    handleClick(row) {
      console.log(row)
    },

    handleEdit(row) {
      this.dialogFormVisible = true
      console.log(row)
    },
    handleClassClick() {
      console.log('班级信息')
      this.$router.push({
        name: 'classlistDescTeacher',
      })
    },

    qrcode() {
      document.getElementById('qrcodeImg').innerHTML = ''

      new QRCode('qrcodeImg', {
        width: 150,
        height: 150,
        text:
          'https://steam.fun/scratch/h5player.html?work_type=1&work_id=' +
          this.workinfo.id +
          '&subject_code=2', // 二维码地址
        colorDark: '#000',
        colorLight: '#fff',
      })

      this.dialogVisible = true
    },
    //老师查看并点评源码

    CommentCode() {
      console.log('老师查看并点评学员源码')
      console.log(this.workinfo)

      if (this.workinfo.work_type == '1') {
        console.log('批改学生课堂作品')
        window.open(
          '/scratch/homework.html?plan_id=' +
          this.workinfo.stu_tch_plan_id +
          '&operate=2' +
          '&stu_user_id=' +
          this.workinfo.stu_user_id
        )
      } else if (this.workinfo.work_type == '2') {
        console.log('批改学生课后作业')
        window.open(
          '/scratch/homework.html?plan_id=' +
          this.workinfo.stu_tch_plan_id +
          '&operate=4' +
          '&stu_user_id=' +
          this.workinfo.stu_user_id
        )
      }
    },
  },
}
</script>

<style>
.el-dialog {
  width: 900px;
}
</style>

<style lang="scss" scoped>
/deep/ .container1 .el-drawer__body {
  overflow: hidden;
}

.school-body {
  margin: 10px;

  .classwrapper {
    border-radius: 5px;
    // overflow-y: scroll;
    background: white;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
    padding-top: 10px;

    .el-col-25 {
      width: 20%;
      margin-bottom: 20px;
    }

    .worklist {
      background: white;
      border-radius: 10px;

      .worklist_imgwrapper {
        width: 100%;
        height: 0;
        padding-bottom: 75%;
        cursor: pointer;

        .workimg {
          width: 100%;
        }
      }

      .work_title {
        padding-top: 10px;

        .work_title_span {
          padding-left: 10px;
          font-size: 14px;
          color: #606266;
          font-weight: bold;

          width: 90%;
          overflow: hidden;
          /*内容超出后隐藏*/
          text-overflow: ellipsis;
          /* 超出内容显示为省略号 */
          white-space: nowrap;
          /* 文本不进行换行 */
        }
      }

      .work_stuinfo {
        padding-left: 5px;

        .work_stuinfo_avatar {
          float: left;
        }
      }

      .work_stuinfo_name {
        .work_stuinfo_name_span {
          line-height: 30px;
          padding-left: 5px;
        }
      }
    }
  }
}
</style>

<style>
.school-body .el-card__body {
  padding: 0px;
}

.container .el-drawer__header {
  margin-bottom: 0px;
  padding: 0px;
  font-weight: bold;
  border-bottom: 0px;
  background: #f9f9f9;
  text-align: center;
}
</style>
